module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/478.77576417.png";